import { getCachedViewSnapshot } from '@databases/database-state/state/view';
import { type DatabaseChangeType } from '@databases/types/redux';

import {
  getNewIndexWithHiddenFields,
  getOrderWithFallback,
  getViewSpecificOrderingExperimentValue
} from '../../../../database/view/view.ts';
import { type YJSChangeHandler } from '../../types.ts';

export const reorderField: YJSChangeHandler<DatabaseChangeType.REORDER_FIELD> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    if (!getViewSpecificOrderingExperimentValue({ fireExperimentExposure: true })) {
      const newIndex = getNewIndexWithHiddenFields(
        change.newIndex,
        db.fields,
        change.hiddenFields
      );

      db.reorderField(change.fieldId, newIndex);
      return;
    }

    const view = getCachedViewSnapshot();
    if (!(view.id in db.viewsById)) {
      return;
    }

    const currentOrder = getOrderWithFallback(
      db.fields,
      db.viewOrders[view.id]?.fieldOrder
    );
    if (!currentOrder.includes(change.fieldId)) {
      return;
    }

    const newIndex = getNewIndexWithHiddenFields(
      change.newIndex,
      currentOrder,
      change.hiddenFields
    );

    db.setViewFieldOrder(view.id, [
      ...currentOrder.slice(0, newIndex).filter((fieldId) => fieldId !== change.fieldId),
      change.fieldId,
      ...currentOrder.slice(newIndex).filter((fieldId) => fieldId !== change.fieldId)
    ]);
  });
};
